export default {
  title: {
    en: 'Take 15% off men\'s grooming<br class="onlyMobile" /> staples for a limited time!',
  },
}
